import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { useWidthContext } from '../../providers/Width';

import './MobileAppQrCode.css';
import { LinkWrapper } from '../LinkWrapper/LinkWrapper';
import { wrapTrademarkSuperscript } from '../../utils/cob-utils';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { Title, Container } from '../../importCL';

interface IAppLink {
    linkTitle: string;
    linkLabel: string;
    linkPath: string;
    newTab: boolean;
}

interface IMobileAppQrCodeProps extends MappedComponentProperties {
    backgroundColor?: string;
    sectionTitle?: string;
    qrCodeImagePath?: string;
    qrCodeAltText?: string;
    qrCodeLabel?: string;
    centerBarText?: string;
    appStoreLinks?: IAppLink[];
}

export const MobileAppQrCodeEditConfig = {
    emptyLabel: 'MobileAppQrCode',
    isEmpty: (props: PropsWithChildren<IMobileAppQrCodeProps>) => {
        return !props || !props.qrCodeImagePath || !props.appStoreLinks || !props.appStoreLinks.length;
    },
};

const MobileAppQrCode = (props: PropsWithChildren<IMobileAppQrCodeProps>): JSX.Element => {
    const { width } = useWidthContext();
    return (
        <div id='mobile-app-qr-code' className='MobileAppQrCode bg-[#f1f1f1]' style={{ backgroundColor: props.backgroundColor }} >
            {width >= 1024 && (
                <article className='MobileAppQrCode__container'>
                    <Title className='mt-0 mb-[-10px] pt-16 leading-6 text-[1.125rem]' tag='h2' align='center'>{transformHTMLParserLinks(wrapTrademarkSuperscript(props.sectionTitle))}</Title>
                    <Container as='div' className='!p-4'>
                        <Container as='div' className='!p-5 !mr-0 !ml-5'>
                            {transformHTMLParserLinks(wrapTrademarkSuperscript(props.qrCodeLabel))}
                            <Container as='div' className='qr-content__qr__circle bg-white !m-5'>
                                <img loading='lazy' src={props.qrCodeImagePath} alt={props.qrCodeAltText} />
                            </Container>
                        </Container>
                        <Container as='div' className='qr-content__v-or !p-0 !mr-0 !-ml-10'>
                            <hr />
                            <Container as='div' className={props.centerBarText ? 'circle' : 'circle--hidden invisible'}>{transformHTMLParserLinks(wrapTrademarkSuperscript(props.centerBarText))}</Container>
                        </Container>
                        <Container as='div' className='flex-col !mr-0 !ml-5 !p-5'>
                            {props.appStoreLinks?.map(link => {
                                return (
                                    <p className='text-center mb-5 text-[1.1rem]' key={link.linkPath}>
                                        {transformHTMLParserLinks(wrapTrademarkSuperscript(link.linkTitle))}
                                        <br />
                                        <LinkWrapper className='LINK font-semibold bg-transparent' href={link.linkPath} target={link.newTab ? '_blank' : ''} >{transformHTMLParserLinks(wrapTrademarkSuperscript(link.linkLabel))}</LinkWrapper>
                                    </p>
                                );
                            })}
                        </Container>
                    </Container>
                </article>
            )}
        </div>
    );
};

export default MobileAppQrCode;
